import View          from '@widesk-ui/components/View';
import TokamapEditor from '@/TokamapEditor';

export default function EditorPage() {
	return (
		<View h="100vh" w="100vw">
			<TokamapEditor />
		</View>
	);
}